import { BackgroundImage } from "@/components/backgroundImage"
import { BackPage } from "@/components/backPage";
import { LogoHeader } from "@/components/logoHeader";
import { Select } from "@/components/select"
import { pedagogico } from "@/constants/pedagogico";
import { useCookies } from "@/hooks/useCookies";

function Pedagogico() {
  useCookies()

  return (
    <div className="mx-auto max-w-[500px] min-h-screen px-2 pb-8">
      <LogoHeader />
      <div className="flex flex-col galp-4 px-4">
        <BackgroundImage height="h-[300px]" alt="Questions-pana.png" src="/assets/Questions-pana.png" />

        <p className="text-2xl font-bold text-center">
          Selecione uma opção
        </p>

        <div className="flex flex-col gap-2 px-2 mt-6 pb-8">
          {pedagogico.filter(item => item.hideIn !== "/setor/secretaria").map((item, idx) => (
            <Select key={idx} idx={idx + 1} id={item.id} label={item.label} />
          ))}
          <BackPage href="/setor" />
        </div>

      </div>

    </div>
  )
}

export default Pedagogico

